import UseLoginToOrganization from "@/hooks/query/organization/UseLoginToOrganization";

const useLoginToTrio = () => {
  const { mutate, isPending } = UseLoginToOrganization();

  const handleLogin = (id: string) => {
    return mutate(
      { organizationId: id },
      {
        onSuccess(data) {
          const url = `${data.data.redirectUrl}/Msp-login?t=${data.data.accessToken}`;
          window.open(url, "_blank", "noopener,noreferrer");
        },
      },
    );
  };

  return { handleLogin, isPending };
};

export default useLoginToTrio;
